import { SubmissionStatus } from "generated-graphql/graphql";

/**
 * Statuses at or past which a submission's content is frozen: the 8700-12
 * snapshot has been taken and the live tables must no longer be edited through
 * the stepper. These are the terminal/post-approval states —
 * `PROCESSING_SUBMISSION` (created on full approval), `FILING_COMPLETE`, and
 * `NOT_REPORTING` (the snapshot is also taken when a submission is marked not
 * reporting). Review states (`ENCAMP_INITIAL_REVIEW`, `IN_REVIEW`) are NOT
 * frozen — no snapshot exists yet and edits can still round-trip.
 */
const FROZEN_SUBMISSION_STATUSES: ReadonlySet<SubmissionStatus> = new Set([
  SubmissionStatus.ProcessingSubmission,
  SubmissionStatus.FilingComplete,
  SubmissionStatus.NotReporting,
]);

/**
 * True when the submission is frozen (read-only) and its content should be read
 * from the snapshot rather than the live tables.
 */
export function isSubmissionFrozen(status: SubmissionStatus | null | undefined): boolean {
  return status != null && FROZEN_SUBMISSION_STATUSES.has(status);
}
